import { useEffect, useState } from 'react';

import type { TreeReplacementDetail } from '../../../../api/workshops';

import { editValuesFrom, toEditPatch } from './tree-replacement-edit';
import { TreeReplacementForm } from './TreeReplacementForm';
import { useUpdateTreeReplacement } from './use-tree-replacements';

/** The edit form on a freshly loaded replacement; sends only what changed. */
export function EditTreeReplacementForm({
  workshopId,
  formId,
  detail,
  onSavingChange,
  onDone,
}: {
  workshopId: string;
  formId: string;
  detail: TreeReplacementDetail;
  onSavingChange: (saving: boolean) => void;
  onDone: () => void;
}) {
  const update = useUpdateTreeReplacement(workshopId);
  useEffect(() => onSavingChange(update.isPending), [update.isPending, onSavingChange]);
  // Fixed for as long as the form is open, so a later refetch can't turn untouched
  // fields into "changes" that would overwrite newer values.
  const [initial] = useState(() => editValuesFrom(detail));
  return (
    <TreeReplacementForm
      formId={formId}
      initial={initial}
      saving={update.isPending}
      error={update.error}
      storedSpecies={detail.treeSpecies ?? null}
      onSubmit={(values) => {
        const patch = toEditPatch(initial, values);
        if (Object.keys(patch).length === 0) return onDone();
        update.mutate({ id: detail.id, patch }, { onSuccess: onDone });
      }}
    />
  );
}
